import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Curriculum from './views/Curriculum.vue';
import Skills from './views/Skills.vue';
import Reports from './views/Reports.vue';
import Impressum from './views/Impressum.vue';
import Kontakt from './views/Kontakt.vue';

Vue.use(Router);

export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    base: process.env.ROUTER_BASE,
    routes: [{
        path: '/',
        name: 'home',
        component: Home
    }, {
        path: '/curriculum',
        name: 'curriculum',
        component: Curriculum
    }, {
        path: '/skills',
        name: 'skills',
        component: Skills
    }, {
        path: '/reports',
        name: 'reports',
        component: Reports
    }, {
        path: '/impressum',
        name: 'impressum',
        component: Impressum
    }, {
        path: '/kontakt',
        name: 'kontakt',
        component: Kontakt
    }]
});
